import { PageHeroTwo } from '@dfh-corp-sites/ui'
import BlockContent from '@sanity/block-content-to-react'
import React from 'react'

import { Cta } from '../../graphql/api'
import {
  LinkFragmentFragment,
  Maybe,
  SanityPageHero,
  SanityRoleBasedContent,
} from '../../graphql/gatsby'
import { useSanityRoleBasedContent } from '../../lib/sanity/hooks/useSanityRoleBasedContent'
import SanityLink from '../global/SanityLink'

export type SanityHeroTagSelection = Pick<NonNullable<SanityPageHero['heroTag']>, 'tag' | 'cta'>

export type SanityPageHeroSelection = Omit<SanityPageHero, 'heroTag'> & {
  heroTag?: Maybe<SanityHeroTagSelection>
}

export interface PageHeroSecondaryProps extends SanityPageHeroSelection {
  className?: string
  title: string
  subtitle?: string
  body?: string
  roleBasedContent?: SanityRoleBasedContent
  mobileTitle?: string
  ctaLinks?: Cta[]
  isTitleTopLevelHeader?: boolean
}

const PageHeroSecondary: React.FC<PageHeroSecondaryProps> = ({
  title,
  mobileTitle,
  subtitle,
  body,
  roleBasedContent,
  ctaLinks,
  isTitleTopLevelHeader,
}) => {
  const { shouldDisplay } = useSanityRoleBasedContent({ roleBasedContent })

  if (!shouldDisplay) {
    return null
  }

  const ctasWithLink = ctaLinks?.map((cta, index) => {
    if (!cta.link) return null
    return (
      <SanityLink key={index} to={cta.link as LinkFragmentFragment}>
        {cta.title}
      </SanityLink>
    )
  })
  const blockContent = body && <BlockContent blocks={body} />
  return (
    <PageHeroTwo
      title={title}
      subtitle={subtitle}
      body={blockContent}
      ctas={ctasWithLink}
      mobileTitle={mobileTitle}
      isTitleTopLevelHeader={isTitleTopLevelHeader}
    />
  )
}

export default PageHeroSecondary
